import { Currency, CurrencySymbol } from 'core/payments/entities';

export type Offer = {
  id: string;
  offerId: string;
  currency: Currency;
  currencySymbol: CurrencySymbol;
  price: number;
  priceWithCurrency: string;
  pricePerDay: null | number;
  period: string;
  trial: boolean;
  trialPrice: number;
  trialPriceWithCurrency: string;
  trialPeriod: string | null;
  trialPricePerDay: null | number;
};

export const sortOffers = (offers?: Array<Offer>) => {
  if (!offers) {
    return [];
  }

  return [...offers].sort((offer1, offer2) => offer1.trialPrice - offer2.trialPrice);
};
